// import { NavLink } from "react-router-dom";
// import { publicUser } from "../../../../../globals/route-names";
import { useTranslation } from "react-i18next";

function SectionJobCategories() {
    const { t } = useTranslation();
    return (
        <>
            <div className="p-t120 p-b90 site-bg-gray twm-job-categories-area2">
                {/* title="" START */}
                <div className="section-head center wt-small-separator-outer">
                    {/* <div className="wt-small-separator site-text-primary">
                        <h2>À propos de nous</h2>
                    </div> */}
                    <h1>{t("Who are we")}?</h1>
                </div>
                {/* title="" END */}
                <div className="container">
                    <div className="twm-job-categories-section-2 m-b30">
                        <div className="job-categories-style1 m-b30">
                            <p>
                                {t("Job Contact is an AI-powered job search and resume automation platform. Our platform helps candidates find job opportunities in Canada and applies for them. We also help foreign workers maximize their chances of landing a job in Canada by adding their profiles to our application database.")}
                                <br /><br />
                                {t("Our main mission is to connect international workers with Canadian employers and recruiters by targeting our job search and CV submission.")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SectionJobCategories;  